import jsonCategories from '@/assets/categories.json';
export const categoryBase = {

    data(){
        return {
            categories:jsonCategories,
        }
    },
    computed:{
		sortedCategories(){
			return this._.sortBy(this.categories, [c => c.name.toLowerCase()]);
        },
    },
    methods: {
        getCategoriesAsString(catIds){
			return this.getArrayAsString(this.categories,catIds);
		},
    }
}